import exceljs from "exceljs";
import moment from "moment";
import { saveAs } from "file-saver";
import BankData from "../json/bank-data.json";
export class ExportCD {
  constructor() {
    // excel file type
  }
  static async saveFile(workbook, fileName) {
    const buffer = await workbook.xlsx.writeBuffer();
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const fileExtension = ".xlsx";
    const blob = new Blob([buffer], { type: fileType });
    return saveAs(blob, fileName + fileExtension);
  }

  static async exportCDInvoice(invoices, startDate, endDate) {
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet("ตั้งหนี้");
    worksheet.columns = [
      {
        header: "วันที่ในบิล",
        key: 1,
        width: 15,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: "เลขที่เอกสาร",
        key: 2,
        width: 15,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: "รหัสลูกค้า",
        key: 3,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: "รหัสสินค้า",
        key: 4,
        width: 15,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: "มิเตอร์เก่า",
        key: 5,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: "มิเตอร์ใหม่",
        key: 6,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: "จำนวน",
        key: 7,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: "ราคา/หน่วย",
        key: 8,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: "ราคารวม",
        key: 9,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: "1=ราคาแยกแวด/2=ราคารวมแวด",
        key: 10,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: "0=เงินสด/มากกว่า1เครดิต",
        key: 11,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: "ลำดับ",
        key: 12,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
    ]

    let index = 0;
    for (let invoice of invoices) {
      let customerMarketId = ""
      if (invoice.contract) {
        customerMarketId = invoice.contract.customerMarketId
      } else if (invoice.booking) {
        customerMarketId = invoice.booking.documentId
      }
      let items = invoice.items || []
      for(let item of items) {
        index++;
        let accountingProduct = item.accountingProduct
        worksheet.addRow({
          1: moment(invoice.date).format("D/M/YYYY"),
          2: invoice.documentId,
          3: customerMarketId || "",
          4: accountingProduct.code || "",
          5: "-",
          6: "-",
          7: item.quantity || 0,
          8: item.pricePerUnit || 0,
          9: item.totalOriginalValue || 0,
          10: item.isVatInclusive ? 2 : 1,
          11: 0,
          12: index
        })
      }
    }
    return this.saveFile(workbook, `cd-invoice-${moment(startDate).format("DDMMYYYY")}-${moment(endDate).format("DDMMYYYY")}`);
  }

  static async exportCDReceipt(receipts, startDate, endDate) {
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet("ตัดหนี้");
    worksheet.columns = [
      {
        header: "วันที่ในบิล",
        key: 1,
        width: 15,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: "เลขที่เอกสาร",
        key: 2,
        width: 15,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: "รหัสลูกค้า",
        key: 3,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: "รหัสสินค้า",
        key: 4,
        width: 15,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: "มิเตอร์เก่า",
        key: 5,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: "มิเตอร์ใหม่",
        key: 6,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: "จำนวน",
        key: 7,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: "ราคา/หน่วย",
        key: 8,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: "ราคารวม",
        key: 9,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: "1=ราคาแยกแวด/2=ราคารวมแวด",
        key: 10,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: "0=เงินสด/มากกว่า1เครดิต",
        key: 11,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: "ลำดับ",
        key: 12,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: "เลขรับเงิน",
        key: 13,
        width: 15,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: "จำนวนเงินที่รับเงินสด",
        key: 14,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: "จำนวนเงินรับเงินโอน",
        key: 15,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: "จำนวนที่รับเข็ค",
        key: 16,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: "เลขที่เช็ค",
        key: 17,
        width: 15,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: "วันที่ในเช็ค",
        key: 18,
        width: 15,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: "ธนาคาร",
        key: 19,
        width: 15,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
    ]

    let index = 0;
    for (let receipt of receipts) {
      let customerMarketId = ""
      if (receipt.contract) {
        customerMarketId = receipt.contract.customerMarketId
      } else if (receipt.booking) {
        customerMarketId = receipt.booking.documentId
      }
      let items = receipt.items || []
      let paymentMethod = receipt.paymentMethod
      let paymentBankAccount = receipt.paymentBankAccount
      for(let item of items) {
        index++;
        let accountingProduct = item.accountingProduct
        let transfer = 0
        let check = 0
        let cash = 0
        if (paymentMethod == 2) {
          transfer = item.totalValue
        } else if (paymentMethod == 6) {
          check = item.totalValue
        } else {
          cash = item.totalValue
        }
        worksheet.addRow({
          1: moment(receipt.date).format("D/M/YYYY"),
          2: receipt.documentId,
          3: customerMarketId || "",
          4: accountingProduct.code || "",
          5: "-",
          6: "-",
          7: item.quantity || 0,
          8: item.pricePerUnit || 0,
          9: item.totalOriginalValue || 0,
          10: item.isVatInclusive ? 2 : 1,
          11: 0,
          12: index,
          13: receipt.documentId,
          14: cash || 0,
          15: transfer || 0,
          16: check || 0,
          17: "-",
          18: "-",
          19: paymentBankAccount ? BankData[paymentBankAccount.bankCode].name_en : "-",
        })
      }
    }
    return this.saveFile(workbook, `cd-receipt-${moment(startDate).format("DDMMYYYY")}-${moment(endDate).format("DDMMYYYY")}`);
  }
}